import { render, staticRenderFns } from "./ShareMore.vue?vue&type=template&id=530d48ae&scoped=true&"
import script from "./ShareMore.vue?vue&type=script&lang=js&"
export * from "./ShareMore.vue?vue&type=script&lang=js&"
import style0 from "./ShareMore.vue?vue&type=style&index=0&id=530d48ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530d48ae",
  null
  
)

export default component.exports